module.exports = __webpack_public_path__ + "assets/img/prize-2.c14116d0.jpg";